/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, inject, signal} from '@angular/core';
import template from './tier-edit-page.component.html';

import {SignalAdminResourceEditPageBase} from '../../common/controller/signal-admin-resource-edit-page-base';
import {initTierModel, isTierEnabled} from './tier-commons';
import {NetworkApiService} from '../network/network-api.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {TierApiService, TierModel} from './tier-api.service';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {AppSharedModule} from '../../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule, FormsModule, TranslateModule, ButtonsModule],
  selector: 'adn-tier-edit-page',
  template
})
export class TierEditPageComponent extends SignalAdminResourceEditPageBase<TierModel> {
  tierEnabled = signal(false);

  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(NetworkApiService) private Network: NetworkApiService
  ) {
    super(inject(TierApiService), 'tier');
  }

  protected override initialiseModel(model: TierModel): TierModel {
    const initialised = super.initialiseModel(model);
    initTierModel(initialised);
    this.loadTierEnabled(initialised.id);
    return initialised;
  }

  protected override afterSave(model: TierModel): void {
    this.loadTierEnabled(model.id);
  }

  private loadTierEnabled(tierId: string): void {
    if (!tierId) {
      this.tierEnabled.set(false);
      return;
    }
    firstValueFrom(this.Network.get(this.LocalNetworkProfile.getNetworkId())).then((network: any) => {
      this.tierEnabled.set(isTierEnabled(tierId, network));
    });
  }
}
